import React, { useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import { Sidebar, StyledCardListOfLinks } from "./style";
import {
  ActionTypes,
  TOOL_OPTIONS_GROUPS
} from "../../../../constants/toolsOptions";
import { checkAccessesForManagerPanel } from "../../../../assets/checkAccess";
import { InitAction } from "../../../../actions";
import { connect } from "react-redux";
import { setMenuColors } from "../../../../assets/setTheme";
import { teamManagementHandle } from "../../../../assets/teamManagementMenuHandle";
import TeamManagementMenuModal from "../../../../projectSpecificComponents/teamManagementMenuModal";
import makeSafeToUseInDangerousInnerHtml from "../../../../lib/makeSafeToUseInDangerousInnerHtml";
import { renderPremiumText } from "../../../../assets/renderPremiumIconWithText";
import { checkPremiumFeature } from "../../../../assets/checkPremium";

const Index = props => {
  const { init, history } = props;
  useEffect(() => {
    if (!init) {
      console.log("in sidebar");
      props.initRequest(); //when come from edit page it does not have data
    }
  }, []);
  const onClickHandle = tool => {
    let checkAction = true;
    if (tool.premium) {
      const showPremiumMessage = checkPremiumFeature(tool.premium, true);
      if (!showPremiumMessage) {
        if (!tool.action && tool.link) {
          checkAction = false;
          history.push(tool.link);
        }
      }
    }
    if (checkAction) {
      switch (tool.action) {
        case ActionTypes.TEAM_MANAGEMENT:
          teamManagementHandle();
          break;
      }
    }
  };
  return (
    <React.Fragment>
      <TeamManagementMenuModal />
      <Sidebar
        color={setMenuColors(false).color}
        backgroundcolor={setMenuColors(false).backgroundColor}
      >
        <ul className="sidebar-list">
          {TOOL_OPTIONS_GROUPS({}, history, init.project).map((group, key) => {
            return (
              <StyledCardListOfLinks key={key}>
                <div className="title">{group.title}</div>
                {group.list
                  .filter(tool => tool.value)
                  .map((tool, i) => {
                    if (
                      !tool.hide &&
                      ((tool.accesses &&
                        checkAccessesForManagerPanel(tool.accesses)) ||
                        !tool.accesses)
                    ) {
                      if (tool.action || tool.premium) {
                        return (
                          <li
                            key={i}
                            className="tool-item"
                            onClick={() => onClickHandle(tool)}
                          >
                            <Link
                              to={(!tool.premium && tool.link) || "#"}
                              disabled
                              className={
                                history.location.pathname.startsWith(tool.link)
                                  ? "active"
                                  : ""
                              }
                            >
                              {tool.icon && (
                                <i className={`icon ${tool.icon}`} />
                              )}
                              {tool.SvgIcon && <tool.SvgIcon />}
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: makeSafeToUseInDangerousInnerHtml(
                                    renderPremiumText(tool.value, showMessage =>
                                      checkPremiumFeature(
                                        tool.premium,
                                        showMessage
                                      )
                                    )
                                  )
                                }}
                              />
                            </Link>
                          </li>
                        );
                      } else {
                        return (
                          <li className="tool-item" key={i}>
                            <Link
                              to={tool.link}
                              className={
                                history.location.pathname.startsWith(tool.link)
                                  ? "active"
                                  : ""
                              }
                            >
                              {tool.icon && (
                                <i className={`icon ${tool.icon}`} />
                              )}
                              {tool.SvgIcon && <tool.SvgIcon />}
                              <span>{tool.value}</span>
                            </Link>
                          </li>
                        );
                      }
                    }
                  })}
              </StyledCardListOfLinks>
            );
          })}
        </ul>
      </Sidebar>
    </React.Fragment>
  );
};

const mapStateToProps = store => {
  return {
    init: store.Init.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    initRequest: () => {
      dispatch(InitAction.get());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Index));
